import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-heart-pulse-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-semibold whitespace-nowrap text-background-50">
                  {t('siteName')}
                </span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed">
                {t('siteDescription')}
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                {t('navCategories')}
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                {t('footerAbout')}
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                    {t('aboutBrandTitle')}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                    {t('aboutReputationTitle')}
                  </Link>
                </li>
                <li>
                  <a href="#contact-form" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                    {t('contactTitle')}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                {t('contactTitle')}
              </h4>
              <p className="text-sm text-background-50/60 leading-relaxed">
                有任何关于按摩教程的问题或建议，欢迎随时与我们联系。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              {t('footerCopyright')}
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-50/40 hover:text-primary-400 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}